import React from 'react';

import { useTranslation } from 'react-i18next';

import { MetaMaskConnectButton, MetaMaskStatus, MetaMaskToolTip } from '@pkg/components';
import { useAppDispatch, useMetaMask } from '@pkg/hooks';

import { NftMintSteps } from '@app/client/common/structs/nft/nft';
import { setNftMintPanelStep } from '@app/store/actions/nft';

import { Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

interface IntroductionProps {
    videoUrl: string;
}

export const Introduction = ({ videoUrl }: IntroductionProps) => {
    const { t } = useTranslation(['nft']);
    const dispatch = useAppDispatch();
    const { isMetaMaskConnected, isMetaMaskInstalled } = useMetaMask();

    const onMetaMaskContinue = () => {
        dispatch(setNftMintPanelStep(NftMintSteps.NameNft));
    };

    const successCallback = isMetaMaskInstalled && isMetaMaskConnected ? onMetaMaskContinue : undefined;

    return (
        <div className="yat-nft-sidebar__step yat-nft__introduction">
            <div className="yat-nft-sidebar__flex-item">
                <Typography type="headline" size={40} classes={['yat-nft-sidebar__title']}>
                    {t('mint_your_yat')}
                </Typography>
                <Typography type="paragraph" size={16} classes={['yat-nft-sidebar__text']}>
                    <span>{t('metamask_not_installed_text', { item: t('translation:yat') })}</span> 🎉
                </Typography>

                <div className="yat-nft-sidebar__visualized_yat">
                    <video autoPlay muted webkit-playsinline="true" playsInline loop>
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                </div>

                <MetaMaskConnectButton successCallback={successCallback} />

                {!isMetaMaskConnected && <MetaMaskToolTip />}
            </div>

            {isMetaMaskConnected && <MetaMaskStatus classes={['yat-nft-sidebar__metamask-status']} />}
        </div>
    );
};
